import { render } from "./TrainingBlock.vue?vue&type=template&id=ae7b6de2"
import script from "./TrainingBlock.vue?vue&type=script&lang=js"
export * from "./TrainingBlock.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TrainingBlock.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36689b7c%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Froadmap%2FTrainingBlock.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__